// Directive: v-waypoint="{ active: true, callback: $_onWaypoint, options: intersectionOptions }"
const waypointEffect = {
  data: () => ({
    intersectionOptions: {
      root: null,
      rootMargin: '0px 0px 0px 0px',
      threshold: 0.35
    } // https://developer.mozilla.org/en-US/docs/Web/API/Intersection_Observer_API
  }),
  methods: {
    $_onWaypoint ({ el, going, direction }) {
      if (going === this.$waypointMap.GOING_IN) {
        el.classList.add('waypoint-fired')
      }
    }
  }
}
export default waypointEffect
